import {
  GETTER_CLINIC_QR_DOCTOR_TOKEN,
  ACTION_SET_CLINIC_QR_DOCTOR_TOKEN,
  ACTION_CLEAR_CLINIC_QR_DOCTOR_TOKEN,
  MUTATE_CLINIC_QR_DOCTOR_TOKEN,
} from './types';

const getDefaultState = () => ({
  doctorToken: null,
});

const state = getDefaultState();

const getters = {
  [GETTER_CLINIC_QR_DOCTOR_TOKEN]: ({doctorToken}) => doctorToken,
};

const actions = {
  [ACTION_SET_CLINIC_QR_DOCTOR_TOKEN]: ({commit}, token) => {
    commit(MUTATE_CLINIC_QR_DOCTOR_TOKEN, token);
  },
  [ACTION_CLEAR_CLINIC_QR_DOCTOR_TOKEN]: ({commit}) => {
    commit(MUTATE_CLINIC_QR_DOCTOR_TOKEN, null);
  },
};

const mutations = {
  [MUTATE_CLINIC_QR_DOCTOR_TOKEN]: (state, token) => {
    state.doctorToken = token;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
